<template>
  <ModalComponent
    id="appointment_rating_pending"
    title="Como foi sua sessão?"
    @modalClosed="handleFinish"
  >
    <template v-slot:body>
      <p class="text-header">Avalie a Qualidade da ligação</p>
      <p class="text-paragraph">
        De uma nota abaixo baseado na qualidade do áudio e vídeo que durante a
        sessão.
      </p>
      <VotingStars
        size="fa-xl"
        @onClick="(rating: number) => setRating(rating)"
      />

      <hr class="mt-4" />

      <p class="text-header">Teve algum problema?</p>
      <p class="text-paragraph">
        Caso teve algum problema ou deseja relatar alguma ocorrência, descreva
        abaixo:
      </p>
      <TextAreaInput :model="descriptionModel" />
    </template>
    <template v-slot:footer>
      <Button label="Pular" @onClick="handleFinish" outline />
      <Button
        label="Enviar avaliação"
        @onClick="submitRating"
        :loading="submitting"
      />
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { appointmentRatingSchema } from "@/schemas/appointment";
import { useAppointmentRatingPendingStore } from "@/store/useAppointmentRatingPendingStore";
import { toggleModal } from "@/utils/Helper";
import { useCreateRating } from "@/composables/useRatings";

const { values, setFieldValue, resetForm } = useForm({
  validationSchema: toTypedSchema(appointmentRatingSchema),
  initialValues: { rating: 0, description: "" },
});

const descriptionModel = useVeeField("description");

const { mutateAsync: createRating, isPending: submitting } = useCreateRating();

function setRating(rating: number) {
  setFieldValue("rating", rating);
}

function handleFinish() {
  resetForm();
  useAppointmentRatingPendingStore().clear();
  toggleModal("appointment_rating_pending");
}

async function submitRating() {
  try {
    await createRating({
      appointment_id: parseInt(useAppointmentRatingPendingStore().pending),
      trouble: false,
      rating: values.rating as number,
      description: values.description as string,
    });
    handleFinish();
  } catch (error) {
    console.error(error);
  }
}
</script>
